<template>
  <b-overlay
    :show="mostrarLoader"
    opacity="0.50"
    rounded="sm"
    spinner-variant="primary"
    spinner-type="grow"
  >
    <div class="clearfix">
      <b-form-group>
        <b-input
          label-placeholder="Nombre"
          placeholder="Nombre"
          v-model="user.first_name"
          v-validate="'required|min:5|max:30|alpha_spaces'"
          :class="[{'is-invalid': errors.has('nombre')}]"
          name="nombre"
          class="w-full"
          maxlength="30"/>
          <span class="text-danger text-sm"  v-show="errors.has('nombre')">{{  errors.first('nombre') }}</span>
      </b-form-group>
      <!--b-input
        label-placeholder="Usuario"
        name="usuario"
        placeholder="Usuario"
        v-model="user.username"
        :danger="errors.has('usuario')"
        v-validate="'required|min:5|max:20|alpha_num'"
        class="w-full mt-6"
        maxlength="20"/>
        <span class="text-danger text-sm"  v-show="errors.has('usuario')">{{  errors.first('usuario') }}</span-->

      <b-form-group>
        <b-input
          name="email"
          type="email"
          label-placeholder="Email"
          placeholder="Email"
          v-model="user.email"
          :class="[{'is-invalid': errors.has('email')}]"
          v-validate="'required|email|max:50'"
          class="w-full mt-6"
          maxlength="50"/>
        <span class="text-danger text-sm"  v-show="errors.has('email')">{{  errors.first('email') }}</span>
      </b-form-group>

      <b-form-group>
        <b-input
          ref="password"
          type="password"
          name="contraseña"
          label-placeholder="Contraseña"
          placeholder="Contraseña"
          v-model="user.password1"
          v-validate="'required|min:5|max:20'"
          :class="[{'is-invalid': errors.has('contraseña')}]"
          class="w-full mt-6"
          maxlength="20"/>
        <span class="text-danger text-sm"  v-show="errors.has('contraseña')">{{  errors.first('contraseña') }}</span>
      </b-form-group>

      <b-form-group>
        <b-input
          type="password"
          data-vv-as="contraseña"
          name="confirm_password"
          label-placeholder="Confirmar Contraseña"
          placeholder="Confirmar Contraseña"
          v-model="user.password2"
          v-validate="'required|confirmed:password|min:5|max:20'"
          :class="[{'is-invalid': errors.has('confirm_password')}]"
          class="w-full mt-6"
          maxlength="20"/>
        <span class="text-danger text-sm"  v-show="errors.has('confirm_password')">{{  errors.first('confirm_password') }}</span>
      </b-form-group>

      <div style="display:flex;" class="mb-2 mt-2">
        <b-form-checkbox
          v-model="isTermsConditionAccepted"
          class="custom-control-primary"
        >
          <span>Acepto <a href="https://signathor.com/terminos-condiciones/" target="_blank">términos & condiciones.</a></span>
        </b-form-checkbox>
      </div>

      <div v-if="principal">
          <b-row>
              <b-col xl="6" md="6" sm="12" xs="12">
                  <b-button variant="outline-primary" type="border" to="/login/" class="mt-6">Iniciar Sesión</b-button>
              </b-col>
              <b-col xl="6" md="6" sm="12" xs="12">
                  <b-button variant="primary" :disabled="bloquearBtn || !isTermsConditionAccepted" id="button-with-loading" class="float-right mt-6 vs-con-loading__container" @click="hayError" >Registrar</b-button>
              </b-col>
          </b-row>
      </div>
      <div v-else>
        <b-button variant="outline-primary" type="border" to="/login/" class="mt-6" style="display: none;">Iniciar Sesión</b-button>
        <b-button variant="primary" :disabled="bloquearBtn || !isTermsConditionAccepted" id="button-with-loading" class="float-right mt-6 vs-con-loading__container" @click="hayError" >Registrar</b-button>
      </div>
    </div>
  </b-overlay>
</template>

<script>
import axios from '@/axios';
import { Validator } from 'vee-validate';
import es from 'vee-validate/dist/locale/es'
Validator.localize("es", es);

export default {
  data () {
    return {
      user:{
        first_name: '',
        username: '',
        email: '',
        password1: '',
        password2: '',
        token_publico: this.$route.params.token_publico
      },
      isTermsConditionAccepted: false,
      bloquearBtn: false,
      plan: '',
      mostrarLoader: false,
    }
  },
  props: {
    principal: {
      type: Boolean,
      default: true
    },
  },
  mounted() {
    this.plan = this.$route.query.plan //antes era $route.query.plan
  },
  methods: {
    registerUserJWt () {
      this.openLoadingContained()
      axios.post('api/accounts/register/',
            {user: this.user, plan: this.plan}
        )
        .then(response => {
           if ( "error"== response.data.status ){
              this.$swal({
                title: 'Error!',
                text: response.data.mensaje[0],
                icon: 'error',
                customClass: {
                  confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
                confirmButtonText: 'Aceptar',
              })
              this.closeLoadingContained()
           }else{
             //poner alerta de cuenta creada, revise su correo, si da confirmar reenvia a login
              this.$swal({
                title: 'Registro exitoso',
                text: 'Se ha enviado un mensaje a su correo electrónico para activar su cuenta.',
                icon: 'success',
                customClass: {
                  confirmButton: 'btn btn-primary',
                },
                buttonsStyling: false,
                confirmButtonText: 'Aceptar',
              }).then((result) => {
                  this.redirigirALogin()
              })
             // if(this.principal){
             //    this.$router.push("/login/")
             // }else{
             //    //this.$router.go()
             //    this.$router.push("/login/")
             // }
           }
        })
    },
      hayError: function(){
        this.openLoadingContained()
        this.$validator.validateAll().then(result => {
                if (result) {
                  // if form have no errors
                  this.registerUserJWt()
                } else {
                  this.closeLoadingContained()
                }
              })

       },

       openLoadingContained(){
          this.bloquearBtn = true
          this.mostrarLoader = true
        },

        closeLoadingContained(){
            this.bloquearBtn = false
            this.mostrarLoader = false
        },

        redirigirALogin(){
          this.$router.push("/login/")
        }
    },
}
</script>
